import ApiClient from '../ApiClient';

const BroadcastService = {

    async broacastMessage(payload) {
        const resp = await ApiClient.post('/Whatsapp/broadcast-message', payload);
        return resp;
    },

    async sendMessage(payload) {
        const resp = await ApiClient.post('/Whatsapp/send-message', payload);
        return resp;
    },

    async getBroadcastHistory(queryParams) {
        const resp = await ApiClient.get(`/Whatsapp/broadcast-history`, { params: queryParams });
        return resp;
    },
}

export default BroadcastService;